/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentPrizeBreakdown
 */
export interface TournamentPrizeBreakdown {
    /**
     * Finishing position where 1 means 1st place
     * @type {number}
     * @memberof TournamentPrizeBreakdown
     */
    place?: number;
    /**
     * Prize amount (in Fuel or cash cents)
     * @type {number}
     * @memberof TournamentPrizeBreakdown
     */
    amount?: number;
    /**
     * This place's share of the winner pool, as a percentage. Set from the payout table; the per-place split is what the percentages describe.
     * @type {number}
     * @memberof TournamentPrizeBreakdown
     */
    percentage?: number;
}

/**
 * Check if a given object implements the TournamentPrizeBreakdown interface.
 */
export function instanceOfTournamentPrizeBreakdown(value: object): value is TournamentPrizeBreakdown {
    return true;
}

export function TournamentPrizeBreakdownFromJSON(json: any): TournamentPrizeBreakdown {
    return TournamentPrizeBreakdownFromJSONTyped(json, false);
}

export function TournamentPrizeBreakdownFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentPrizeBreakdown {
    if (json == null) {
        return json;
    }
    return {
        
        'place': json['place'] == null ? undefined : json['place'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
    };
}

export function TournamentPrizeBreakdownToJSON(json: any): TournamentPrizeBreakdown {
    return TournamentPrizeBreakdownToJSONTyped(json, false);
}

export function TournamentPrizeBreakdownToJSONTyped(value?: TournamentPrizeBreakdown | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'place': value['place'],
        'amount': value['amount'],
        'percentage': value['percentage'],
    };
}

